import { download } from './utils/download';
import { print } from './utils/print';
import { isPrintAllowed } from './utils/isPrintAllowed';
import { isDownloadAllowed } from './utils/isDownloadAllowed';
import { downloadAttachmentFromUrl } from './utils/downloadAttachmentFromUrl';
import { openInNewTab } from './utils/openInNewTab';

export {
    download,
    print,
    isPrintAllowed,
    isDownloadAllowed,
    downloadAttachmentFromUrl,
    openInNewTab,
};
